<template>
    <task-group-list
        :abstractSchemaConfig="protocol"
        :task-groups="taskGroups"
        :readout-groups="readoutGroups"
        @create="createTaskGroup"
        @update="updateTaskGroup"
        @delete="deleteTaskGroup"
    />
</template>
<script>
import { defineComponent } from "vue";

import { buildProtocolTaskGroupsAPI } from "@/services/api.services";
import TaskGroupList from "../Measurements/TaskGroupList.vue";
import { withLoadingScreen } from "@/lib/loading";

export default defineComponent({
    components: { TaskGroupList },

    props: {
        protocol: {
            type: Object,
            required: true,
        },
        readoutGroups: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            protocolTaskGroupsAPI: null,
            protocolReadoutGroupsAPI: null,
            taskGroups: [],
        };
    },

    async mounted() {
        this.protocolTaskGroupsAPI = buildProtocolTaskGroupsAPI(this.protocol.code);
        await withLoadingScreen(async () => {
            this.taskGroups = await this.protocolTaskGroupsAPI.fetchAll();
        });
    },

    methods: {
        createTaskGroup(readoutGroup) {
            return this.save(() => this.protocolTaskGroupsAPI.create(readoutGroup));
        },
        updateTaskGroup(readoutGroup) {
            return this.save(() => this.protocolTaskGroupsAPI.update(readoutGroup));
        },
        async save(saveFn) {
            return withLoadingScreen(async () => {
                await saveFn();
                this.taskGroups = await this.protocolTaskGroupsAPI.fetchAll();
                this.$emit("saved");
            });
        },
        async deleteTaskGroup(taskGroup) {
            return withLoadingScreen(async () => {
                await this.protocolTaskGroupsAPI.delete(taskGroup.id);
                this.taskGroups = await this.protocolTaskGroupsAPI.fetchAll();
                this.$emit("deleted");
            });
        },
    },
});
</script>
<style></style>
